import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import LogoHead from '../logos/LogoHead';

const LandingNav = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[rgba(5,8,16,0.85)] backdrop-blur-xl border-b border-white/5 shadow-xl' : 'bg-transparent'}`}>
            <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
                {/* Logo — Felix orangutan PNG has a transparent background, so
                     a square box-shadow wrapper made it look like the logo had
                     an invisible rectangular backdrop. Dropping the wrapper and
                     applying `filter: drop-shadow()` directly to the image
                     makes the glow trace the orangutan's outline instead. */}
                <Link to="/" className="flex items-center gap-2.5 group">
                    <LogoHead
                        className="w-9 h-9 transition-all"
                        style={{ filter: 'drop-shadow(0 0 8px rgba(24,181,240,0.45))' }}
                    />
                    <span className="font-heading font-bold text-xl tracking-tight text-white">Helix</span>
                </Link>

                {/* Nav links — Community link removed while the Gallery
                     section is hidden; restore when LandingCommunity ships. */}
                <div className="hidden md:flex items-center gap-8">
                    {[
                        { label: 'Features', href: '#features' },
                        { label: 'Demo', href: '#demo' },
                        { label: 'Pricing', href: '#pricing' },
                    ].map(({ label, href }) => (
                        <a
                            key={label}
                            href={href}
                            className="text-sm text-[var(--text-secondary)] hover:text-white transition-colors"
                        >
                            {label}
                        </a>
                    ))}
                </div>

                {/* CTA */}
                <div className="flex items-center gap-3">
                    <Link
                        to="/login"
                        className="text-sm font-semibold text-[var(--text-secondary)] hover:text-white transition-colors"
                    >
                        Log In
                    </Link>
                    <Link
                        to="/signup"
                        className="text-sm font-bold bg-[var(--primary-color)] text-black px-4 py-2 rounded-lg hover:brightness-110 transition-all shadow-[0_0_12px_rgba(24,181,240,0.3)]"
                    >
                        Get Started
                    </Link>
                </div>
            </div>
        </nav>
    );
};

export default LandingNav;
